"use client";

import { Component, type ErrorInfo, type ReactNode } from "react";
import { rememberProblemRenderError } from "@/lib/problem-render-diagnostics";

interface Props {
  pathname: string;
  problemIds: readonly string[];
  children?: ReactNode;
}

/** 진단만 추가하고 원래 오류를 상위 Next 오류 경계로 전달한다. */
export default class ProblemRenderDiagnosticsBoundary extends Component<Props> {
  componentDidCatch(error: Error, info: ErrorInfo) {
    rememberProblemRenderError(error, info, this.props.pathname, this.props.problemIds);
    // 여기서 별도로 전송하지 않아 error.tsx의 기존 보고와 중복되지 않는다.
    // 상위 오류 경계가 기존 오류 화면/재시도와 하위 트리 재마운트를 담당한다.
    throw error;
  }

  render() {
    return this.props.children;
  }
}
